import { gql } from "apollo-angular";

export default gql`
  query CompaniesOverview(
    $list: CompaniesList!
    $filter: CompaniesFilter!
    $registeredCountriesFilter2: RegisteredCountriesFilterInput
  ) {
    companies(list: $list, filter: $filter) {
      metaData {
        count
      }
      objects {
        id
        name
        createdAt
        countryCode
        partialExemption
        registeredCountries(filter: $registeredCountriesFilter2) {
          objects {
            countryCode
            registrationPeriod {
              from
              to
            }
          }
        }
      }
    }
  }
`;
